import React from "react";
import { Route, Routes } from "react-router-dom";
import AuthOffline from "@seims/shared/src/security/AuthOffline";
import FAQ from "../common/components/FAQ";
import AboutUsView from "../common/components/AboutUsView";
import { PrivacyStatment, TermsAndConditions } from "@seims/shared/src/components/usermanagement";
import { HomeView } from "../menu/home/HomeView";
import { AuthenticatedRoute, RouteByRole } from "@seims/shared/src/security/ProtectedRoutes";
import { UserProfileView } from "../components/UserProfileView";
import { UpdatePasswordView } from "src/components/UpdatePasswordView";

import {
  InvalidPage,
  ListingEvents,
  AddEditEvent,
  AddDataCapturerToEvent,
  CaptureAttendee,
  GroupCapturing,
  IndividualCapturing,
  RegisterUser,
  ScienceFacilitatorsCapturing,
  EventsHelp,
} from "@seims/shared";

const AppRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<HomeView />} />
      <Route path="/autherror" element={<AuthOffline />} />

      {/* <Route path="/login" element={<LoginView />} />
      <Route path="/login/:key/:isanon" element={<LoginView />} /> */}
      <Route path="/privacy-statement" element={<PrivacyStatment />} />
      <Route path="/terms-and-conditions" element={<TermsAndConditions />} />

      <Route path="/profile" element={<AuthenticatedRoute > <UserProfileView /> </AuthenticatedRoute>}/>
      <Route path="/changepassword" element={<AuthenticatedRoute > <UpdatePasswordView /> </AuthenticatedRoute>}/>
      <Route path="/register" element={<RegisterUser defaultProgramme="events-tracker"/>} />

      <Route path="/faq" element={<FAQ />} />
      <Route path="/about-us" element={<AboutUsView />} />
      <Route path="/events/help" element={<RouteByRole roles={["EVENT_ORGANISER"]}> <EventsHelp /></RouteByRole>} />

      <Route path="/events" element={<RouteByRole roles={["EVENT_ORGANISER"]}> <ListingEvents /> </RouteByRole>} />
      {/* <Route path="/new-events" element={<ListingEvents />} /> */}
      <Route path="/events/add" element={<RouteByRole roles={["EVENT_ORGANISER"]}> <AddEditEvent /></RouteByRole>} />
      <Route path="/events/edit/:id" element={<RouteByRole roles={["EVENT_ORGANISER"]}> <AddEditEvent /></RouteByRole>} />
      <Route path="/events/view/:id" element={<RouteByRole roles={["EVENT_ORGANISER"]}> <AddEditEvent /></RouteByRole>} />
      <Route path="/events/data-capturers/:id" element={<RouteByRole roles={["EVENT_ORGANISER"]}> <AddDataCapturerToEvent /></RouteByRole>} />

      <Route
        path="/events/capture/:eventId/attendees"
        element={<RouteByRole roles={["EVENT_ORGANISER"]}> <CaptureAttendee /></RouteByRole>}
      >
        {/* DEFAULT TAB (HOME) */}
        <Route index element={<IndividualCapturing />} />

        <Route
          path="individual"
          element={<IndividualCapturing />}
        />

        <Route
          path="group"
          element={<GroupCapturing />}
        />

        <Route
          path="science-facilitator"
          element={<ScienceFacilitatorsCapturing />}
        />
      </Route>
      {/* <Route index element={<IndividualCapturing />} />
      <Route path="/events/capture/:eventId/attendees/individual" element={<IndividualCapturing />} />
      <Route path="/events/capture/:eventId/attendees/group" element={<GroupCapturing />} />
      <Route path="/events/capture/:eventId/attendees/science-facilitators" element={<ScienceFacilitatorsCapturing />} /> */}

      <Route path="/404/" element={<InvalidPage />} />
      {/* Only match this 👇️ when no other routes match */}
      <Route path="*" element={<InvalidPage subTitle={"Page Not Found"} />} />
    </Routes>
  );
};

export default AppRouter;
